import queryString from "query-string";

const urlToKey = url => `cache:${url}`;

const _getSession = ({ key: _key }) => {
  const key = urlToKey(_key);
  const _value = window.sessionStorage.getItem(key) || null;
  return typeof _value === "string" ? Number(_value) : undefined;
};

const _setSession = ({ key: _key, value }) => {
  const key = urlToKey(_key);
  window.sessionStorage.setItem(key, value);
  return value;
};

export const fetchUnvisitedPlacesNearbyCount = (): Function => (
  state,
  actions,
): Promise<void> => {
  const {
    api,
    clientID,
    unvisitedPlaces: {
      category: { id: categoryID },
      portifolio: { id: unvisitedPlacesPortifolioID },
      since,
      until,
      selectedPlace,
    },
    unvisitedPlacesNearby: {
      coordinates,
      keyword,
      portifolio: { id: portifolioID },
      radius,
    },
  } = state;

  const headers = new Headers({ authorization: state.authorization });
  const queryParameters = queryString.stringify({
    categoryID,
    coordinates: selectedPlace.coordinates,
    keyword,
    pageNumber: 1,
    pageSize: 1,
    placeCountOnly: true,
    portifolioID: portifolioID || unvisitedPlacesPortifolioID,
    radius: state.unvisitedPlaces.radius,
    since,
    until,
  });
  const url = `${api}/v1/unvisited-places/${clientID}?${queryParameters}`;
  const placeCountFromCache = _getSession({ key: url });

  if (typeof placeCountFromCache != "number") {
    const fetching = fetch(url, { headers });
    fetching
      .then(response => response.json())
      .then(({ placeCount }) => {
        if (typeof placeCount === "number") {
          _setSession({ key: url, value: placeCount });
          actions.setUnvisitedPlacesCount({
            placeCount,
            isLoading: false,
          });
        }
      })
      .catch(reason => actions.setPlacesFailed({ reason }));
  } else {
    const placeCount = placeCountFromCache;
    return actions.setUnvisitedPlacesCount({
      placeCount,
      isLoading: false,
    });
  }

  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      pagination: {
        ...state.unvisitedPlaces.pagination,
        isLoading: true,
        itemCount: undefined,
        pageCount: undefined,
      },
    },
  };
};
